import { Controller } from "stimulus"
import { createElement } from "../helpers"

export default class extends Controller {
  static values = { url: String }

  storageKey = "open_desktop_app"

  initialize() {
    this.iframe = createElement("iframe", { src: this.urlValue, hidden: true })
  }

  connect() {
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start = () => {
    if (this.disabled) return

    if (this.enabled) {
      requestAnimationFrame(this.enable)
    } else if (document.hasFocus()) {
      addEventListener("blur", this.enable)
      this.timeout = setTimeout(this.disable, 2500)
    } else {
      this.timeout = setTimeout(this.stop, 250)
    }

    this.element.append(this.iframe)
  }

  stop = () => {
    removeEventListener("blur", this.enable)
    clearTimeout(this.timeout)
    this.iframe.remove()
  }

  enable = () => {
    this.stop()
    document.cookie = `${this.storageKey}=1`
    this.element.showPopover()
  }

  disable = () => {
    this.stop()
    document.cookie = `${this.storageKey}=0`
    this.element.hidePopover()
  }

  get enabled() {
    return document.cookie.includes(`${this.storageKey}=1`)
  }

  get disabled() {
    return document.cookie.includes(`${this.storageKey}=0`)
  }
}
